import React from 'react';
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonBadge,
} from '@ionic/react';
import { useTimer } from '../../contexts/TimerContext';
import { useTrainingStore } from '../../stores/useTrainingStore';

import { barbellOutline } from 'ionicons/icons';

const GlobalTimerHeader: React.FC = () => {
  const { isRunning } = useTimer();
  const syncStatus = useTrainingStore(state => state.syncStatus);
  if (!isRunning) return null;

  const badge = {
    offline: { color: 'danger', label: 'Offline' },
    local: { color: 'warning', label: 'Saved locally' },
    syncing: { color: 'tertiary', label: 'Syncing' },
    synced: { color: 'success', label: 'Synced' },
  }[syncStatus];

  return (
    <IonHeader>
      <IonToolbar>
        {isRunning && (
          <IonButtons slot="end">
            <IonButton color="dark" size="small" routerLink="/my/trainingstart">
              <IonIcon slot="start" icon={barbellOutline}></IonIcon>
              Training in progress
            </IonButton>
            <IonBadge color={badge.color as any}>{badge.label}</IonBadge>
          </IonButtons>
        )}
      </IonToolbar>
    </IonHeader>
  );
};

export default GlobalTimerHeader;
